import { combineReducers } from 'redux';

import loadSiteTextsWithConfigError from './loadSiteTextsWithConfigError';
import editSiteTextsError from './editSiteTextsError';
import deleteSiteTextsError from './deleteSiteTextsError';


export default combineReducers({
  loadSiteTextsWithConfigError,
  editSiteTextsError,
  deleteSiteTextsError,
});
